import { eventPost } from '@/lib/events';

export interface OrderLabInput {
  withingsUserId: string | number;
  taskId: string | number;
  tests: string[];
  icd10Codes?: string[];
  priority?: string;
  labVendor?: string;
  notes?: string;
  orderedByRole?: string;
  orderedByName?: string;
  orderedByUserId?: string | number;
}

export async function orderLabInElation({
  withingsUserId,
  taskId,
  tests,
  icd10Codes = [],
  priority = 'routine',
  labVendor,
  notes,
  orderedByRole = 'clinician',
  orderedByName,
  orderedByUserId,
}: OrderLabInput): Promise<unknown> {
  if (!withingsUserId) throw new Error('orderLabInElation: withingsUserId required');
  if (!taskId) throw new Error('orderLabInElation: taskId required');
  if (!Array.isArray(tests) || tests.length === 0) {
    throw new Error('orderLabInElation: at least one test is required');
  }
  return eventPost('lab_order_requested', {
    id_dev_user: String(withingsUserId),
    task_id: taskId,
    tests,
    icd10_codes: icd10Codes,
    priority,
    lab_vendor: labVendor,
    notes,
    ordered_by_role: orderedByRole,
    ordered_by_name: orderedByName,
    ordered_by_user_id: orderedByUserId,
  });
}
